import { useCallback, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../Context/Auth.context';

export const useHttp = (isAddToken = true) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { logout, token } = useContext(AuthContext);
    const navigate = useNavigate();
    const request = useCallback(
        async (
            url,
            method = 'GET',
            body = null,
            headers = {},
            isDownload = false,
            file = null,
            isCustomUrl = false
        ) => {
            setLoading(true);
            try {
                if (body && !file) {
                    body = JSON.stringify(body);
                    headers['Content-Type'] = 'application/json';
                    headers.accept = 'application/json';
                } else if (file) {
                    const formData = new FormData();
                    Object.keys(body).forEach((key) => {
                        formData.append(key, body[key]);
                    });
                    formData.append('file', file);
                    body = formData;
                }

                if (token && isAddToken) {
                    headers.Authorization = `Bearer ${token}`;
                }
                const res = await fetch(
                    !isCustomUrl ? url : process.env.REACT_APP_BASE_URL + url,
                    { method, body, headers }
                );
                if (res.status === 204) {
                    setLoading(false);
                    return {};
                }
                const data = !isDownload ? await res.json() : await res.blob();
                if (res.status >= 300) {
                    if (res.status === 401) {
                        logout();
                        if (token) {
                            navigate('/login');
                        }
                        return {
                            error: {
                                status: res.status,
                                message:
                                    'Время авторизации вышло. Авторизуйтесь снова.',
                            },
                        };
                    }
                    setLoading(false);
                    return {
                        error: {
                            status: res.status,
                            message: data?.message ?? '',
                        },
                    };
                } else {
                    setLoading(false);
                    return data;
                }
            } catch (e) {
                setLoading(false);
                setError(e.message);
                // throw error;
            } finally {
                setLoading(false);
            }
        },
        [logout, token]
    );
    const clearError = useCallback(() => setError(null), []);
    return { loading, request, error, clearError };
};
